import * as React from 'react';
import { TImprovedContentMarketing } from '../../../../shared/types/contentMarketing';
import { getExperimentVariantFromConfig } from '../../../config';
import { Clickable } from '@fabric-ds/react';
import { UNLEASH_FEATURE_NAMES } from '../../../../shared/unleash/feature-names';
import { useMemo } from 'react';

type ContentMarketingTextContainerType = {
    smallText?: boolean;
    disableTextBalancer?: boolean;
    hideSponsor?: boolean;
    contentMarketing: TImprovedContentMarketing;
};

const TextContainer = ({
    contentMarketing,
    hideSponsor = false,
}: // smallText = false,
ContentMarketingTextContainerType) => {
    // const { deviceType } = getConfig();
    // const isMobile = deviceType === 'mobile';
    const title = contentMarketing.title.replace(/\\n/g, '<br/>');
    const cleanTitle = contentMarketing?.title.replace(/\\n/g, '');

    // const ref = useRef<HTMLParagraphElement>();
    // useTextBalancer(ref, disableTextBalancer || isMobile);

    const fontSizeExperiment = getExperimentVariantFromConfig(
        UNLEASH_FEATURE_NAMES.largeFontSizeContentMarketingExperiment,
    ) as
        | 'control'
        | 'challenger14reg18med'
        | 'challenger14med20med'
        | 'challenger14reg20reg'
        | 'challenger16med28reg';

    const { smallTextStyle, bigTextStyle } = useMemo(() => {
        switch (fontSizeExperiment) {
            case 'challenger14reg18med':
                return {
                    smallTextStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                        lineHeight: '18px',
                    },
                    bigTextStyle: {
                        fontSize: 18,
                        fontWeight: 'bold',
                        lineHeight: '24px',
                    },
                };
            case 'challenger14med20med':
                return {
                    smallTextStyle: {
                        fontSize: 14,
                        fontWeight: 'bold',
                        lineHeight: '18px',
                    },
                    bigTextStyle: {
                        fontSize: 20,
                        fontWeight: 'bold',
                        lineHeight: '24px',
                    },
                };
            case 'challenger14reg20reg':
                return {
                    smallTextStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                        lineHeight: '18px',
                    },
                    bigTextStyle: {
                        fontSize: 20,
                        fontWeight: 'normal',
                        lineHeight: '24px',
                    },
                };
            case 'challenger16med28reg':
                return {
                    smallTextStyle: {
                        fontSize: 16,
                        fontWeight: 'bold',
                        lineHeight: '24px',
                    },
                    bigTextStyle: {
                        fontSize: 28,
                        fontWeight: 'normal',
                        lineHeight: '32px',
                    },
                };
            default:
                return {
                    smallTextStyle: {
                        fontSize: 16,
                        fontWeight: 'bold',
                        lineHeight: '20px',
                    },
                    bigTextStyle: {
                        fontSize: 22,
                        fontWeight: 'normal',
                        lineHeight: '28px',
                    },
                };
        }
    }, [fontSizeExperiment]);

    const accessibilityId = `cm-title-${contentMarketing.id}`;
    return (
        <div>
            {!hideSponsor && Boolean(contentMarketing.sponsorData.name) && (
                <div className={`text-gray-500 text-14 mb-4`}>
                    <span>{contentMarketing.sponsorData.name}</span>
                </div>
            )}
            {!!contentMarketing.text && (
                <div className={`mb-0 text-left`} style={smallTextStyle}>
                    {contentMarketing.text}
                </div>
            )}
            <h2
                className={`font-normal text-left mb-0 whitespace-pre-wrap text-ellipsis no-underline`}
                id={accessibilityId}
            >
                <Clickable
                    href={contentMarketing.href}
                    rel="noreferrer"
                    target="_blank"
                    title={cleanTitle}
                    id={accessibilityId}
                    className={
                        'link link--dark sf-ad-link text-gray-700 hover:no-underline focus:no-underline focus-ring'
                    }
                >
                    <div
                        className={`w-full text-left`}
                        style={bigTextStyle}
                        data-testid={'cm-title'}
                    >
                        {/*<div*/}
                        {/*    className={'balance-text'}*/}
                        {/*    data-testid={'cm-title'}*/}
                        {/*    ref={ref}*/}
                        {/*>*/}
                        {title}
                        {/*</div>*/}
                    </div>
                </Clickable>
            </h2>
        </div>
    );
};

export default TextContainer;
